import React, { ChangeEvent, ReactNode } from 'react';

// Material ui
import { Grid, Switch, Checkbox as MaterialCheckBox } from '@material-ui/core';

// Components
import Typography from '@components/UI-KIT/Typography';

// Icons
import { CheckboxUnchecked, CheckboxChecked } from '@/assets/icons';

// Styles
import './Checkbox.scss';

interface Props {
    checked: boolean;
    value?: any;
    disabled?: boolean;
    onChange: (_e?: ChangeEvent<HTMLInputElement>) => void;
    label?: string | ReactNode;
    className?: string;
    variant?: 'normal' | 'switch';
    color?: 'primary' | 'secondary' | 'primary-dark';
    typographyVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'table-regular' | 'table-underline' | 'table-semibold' | 'input-head' | 'body-regular' | 'body-semibold' |'note-regular' | 'note-semibold' | 'steps';
}

const Checkbox: React.FC<Props> = ({
    checked,
    disabled = false,
    label,
    onChange,
    className,
    variant = 'normal',
    value,
    color = 'primary-dark',
    typographyVariant = 'body-regular'
}) => (
    <Grid
        container
        alignItems="center"
        className={`ui-Checkbox-input${className ? ` ${className}` : ''}`}
    >
        { variant === 'normal' && (
            <MaterialCheckBox
                disableRipple
                classes={{
                    root: 'ui-Checkbox-root',
                    checked: 'ui-Checkbox-checked'
                }}
                checked={checked}
                disabled={disabled}
                onChange={onChange}
                value={value}
                icon={<CheckboxUnchecked />}
                checkedIcon={<CheckboxChecked />}
            />
        )}
        { variant === 'switch' && (
            <Switch
                disableRipple
                classes={{
                    root: `ui-Switch-container${disabled ? ' ui-Switch-disabled' : ''}`,
                    switchBase: 'ui-Switch-root',
                    thumb: 'ui-Switch-thumb',
                    track: 'ui-Switch-track',
                    checked: 'ui-Switch-checked',
                    disabled: 'ui-Switch-disabled'
                }}
                checked={disabled ? false : checked}
                disabled={disabled}
                onChange={onChange}
                value={value}
            />
        )}
        <Typography
            variant={typographyVariant}
            color={color}
        >
            {label || <>&nbsp;</> }
        </Typography>
    </Grid>
);

export default Checkbox;
